import request from './request'
// let resquest = '/api'
let resquest = ''

const http = {
    /**
     * methods: 请求
     * @param url 请求地址 
     * @param params 请求参数
     */
    get(url,params) {
        const config = {
            method: 'get',
            url: `${resquest}` + url
        }
        if (params) config.params = params
        return request(config)
    },
    post(url,params, isBody) {
        const config = {
            method: 'post',
            url: `${resquest}` + url
        }
        if (params && !isBody) config.params = params
        if (params && isBody) config.data = params;
        return request(config)
    },
    put(url,params, isBody) {
        const config = {
            method: 'put',
            url: `${resquest}` + url
        }
        if (params && !isBody) config.params = params
        if (params && isBody) config.data = params;
        return request(config)
    },
    delete(url,params) {
        const config = {
            method: 'delete',
            url: `${resquest}` + url
        }
        if (params) config.params = params
        return request(config)
    },
}
//导出
export default http